const acoCartRequests = (() => {
  let pending = 0;
  let revision = 0;
  const isMutation = (input, init) => {
    try {
      const url = new URL(typeof input === 'string' || input instanceof URL ? input : input.url, location.href);
      const method = String(init?.method || input?.method || 'GET').toUpperCase();
      return method === 'POST' && url.origin === location.origin && /\/cart\/(add|change|update|clear)(?:\.js|\.json)?\/?$/.test(url.pathname);
    } catch { return false; }
  };
  const begin = () => {
    pending++;
    revision++;
    document.dispatchEvent(new CustomEvent('aco:cart-request-start'));
  };
  const end = () => {
    pending--;
    revision++;
    document.dispatchEvent(new CustomEvent('aco:cart-request-end'));
  };
  const previousFetch = window.fetch;
  window.fetch = function(input, init) {
    if (!isMutation(input, init)) return previousFetch.apply(this, arguments);
    begin();
    try { return Promise.resolve(previousFetch.apply(this, arguments)).finally(end); }
    catch (error) { end(); throw error; }
  };
  const requests = new WeakMap();
  const previousOpen = XMLHttpRequest.prototype.open;
  const previousSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function(method, url) {
    const result = previousOpen.apply(this, arguments);
    requests.set(this, isMutation(url, {method}));
    return result;
  };
  XMLHttpRequest.prototype.send = function() {
    if (!requests.get(this)) return previousSend.apply(this, arguments);
    begin();
    let finished = false;
    const finish = () => { if (!finished) { finished = true; end(); } };
    this.addEventListener('loadend', finish, {once: true});
    try { return previousSend.apply(this, arguments); }
    catch (error) { this.removeEventListener('loadend', finish); finish(); throw error; }
  };
  return {
    get pending() { return pending; },
    get revision() { return revision; },
    waitForIdle() {
      if (!pending) return Promise.resolve();
      return new Promise((resolve, reject) => {
        const cleanup = () => { clearTimeout(timer); document.removeEventListener('aco:cart-request-end', check); };
        const check = () => { if (!pending) { cleanup(); resolve(); } };
        const timer = setTimeout(() => { cleanup(); reject(new Error('Cart update is still pending')); }, 10000);
        document.addEventListener('aco:cart-request-end', check);
        check();
      });
    }
  };
})();
